import React from 'react';
import { Pagination } from 'react-bootstrap';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 0.5rem;

  .pagination {
    justify-content: space-between;
  }

  .page-link {
    background: rgba(10, 10, 12, 0.72);
    border-color: rgba(148, 163, 184, 0.25);
    color: #e2e8f0;
  }

  .page-item.disabled .page-link {
    background: rgba(15, 23, 42, 0.5);
    color: #64748b;
  }

  .page-link:hover:not(.disabled) {
    background: rgba(52, 211, 153, 0.15);
    border-color: rgba(52, 211, 153, 0.35);
    color: #34d399;
  }
`;

const TotalText = styled.div`
  margin: 1em 0;
  color: #94a3b8;
  font-size: 15px;

  b {
    color: #e2e8f0;
  }
`;

interface PaginationBarProps {
  onPreviousClick: () => void;
  onNextClick: () => void;
  isFirstPage: boolean;
  isLastPage: boolean;
  totalRecords: number;
  isDisabled?: boolean;
}

export const PaginationBar: React.FC<PaginationBarProps> = ({
  onPreviousClick,
  onNextClick,
  isFirstPage,
  isLastPage,
  totalRecords,
  isDisabled = false,
}) => {
  return (
    <Wrapper>
      <TotalText>
        About <b>{totalRecords}</b> records
      </TotalText>
      <Pagination size="lg">
        <Pagination.First disabled={isFirstPage || isDisabled} onClick={onPreviousClick} />
        <Pagination.Last disabled={isLastPage || isDisabled} onClick={onNextClick} />
      </Pagination>
    </Wrapper>
  );
};

export default PaginationBar;
